export default {
  FETCH_REGISTRATION_STATUS_REQUEST: 'FETCH_REGISTRATION_STATUS_REQUEST',
  FETCH_REGISTRATION_STATUS_ERROR: 'FETCH_REGISTRATION_STATUS_ERROR',
  FETCH_REGISTRATION_STATUS_SUCCESS: 'FETCH_REGISTRATION_STATUS_SUCCESS'
}
